import { metrics } from '@seek/metrics-js';
import { useEffect } from 'react';

import { Page, PageSection, useTrackingClient } from 'src/context/tracking';

export function useTracking({
  loading = true,
  skillCount = 0,
  unconfirmedRoleCount = 0,
  unconfirmedQualificationCount = 0,
}) {
  const client = useTrackingClient({
    pageTitle: Page.PROFILE_PAGE,
    currentPage: Page.PROFILE_PAGE,
  });

  useEffect(() => {
    if (loading) return;

    client.trackView({
      view: Page.PROFILE_PAGE,
      currentPageSection: PageSection.PROFILE,
      eventName: ['apply_profile_displayed'],
      skillsTotal: skillCount,
    });

    metrics.count('APPLY_PROFILE_DISPLAYED');
  }, [client, skillCount, loading]);

  useEffect(() => {
    if (
      loading ||
      unconfirmedRoleCount === 0 ||
      unconfirmedQualificationCount === 0
    ) {
      return;
    }
    metrics.count('unconfirmed-data-impression', [
      `rolesFound:${unconfirmedRoleCount > 0}`,
      `qualificationsFound:${unconfirmedQualificationCount > 0}`,
    ]);

    client.trackLink({
      link: 'resume_parsed_succeeded',
      currentPage: 'apply documents',
      parsedData: [
        {
          document: 'resume',
          section: 'career-history',
          info: unconfirmedRoleCount > 0 ? 'new-info' : 'no-new-info',
          count: unconfirmedRoleCount,
        },
        {
          document: 'resume',
          section: 'education',
          info: unconfirmedQualificationCount > 0 ? 'new-info' : 'no-new-info',
          count: unconfirmedQualificationCount,
        },
      ],
    });
  }, [client, unconfirmedRoleCount, unconfirmedQualificationCount, loading]);
}
